/**
 * Main JavaScript File
 * 
 * Handles mobile menu toggle and other interactive functionality.
 */

(function($) {
    'use strict';

    /**
     * FAQ Accordion Functionality
     * 
     * Handles the accordion toggle for FAQ items
     */
    function initFAQAccordion() {
        $('.faq-header').on('click', function() {
            const $faqItem = $(this).closest('.faq-item');
            const $faqContent = $faqItem.find('.faq-content');
            const isActive = $faqItem.hasClass('faq-item--active');
            const $accordion = $faqItem.closest('.faq-accordion');
            const $allFaqItems = $accordion.find('.faq-item');
            const isMobile = window.innerWidth <= 767;
            const paddingValue = isMobile ? '0 20px' : '0 30px';
            const openPadding = isMobile ? '20px' : '30px';

            // If clicking on already active item, keep it open (don't allow closing all items)
            if (isActive) {
                return;
            }

            // Close all FAQ items within the same accordion
            $allFaqItems.removeClass('faq-item--active');
            $allFaqItems.find('.faq-content').css({
                'max-height': '0',
                // 'padding': paddingValue,
                'opacity': '0'
            });
            $allFaqItems.find('.faq-header').attr('aria-expanded', 'false');

            // Open clicked item
            $faqItem.addClass('faq-item--active');
            const contentHeight = $faqContent[0].scrollHeight;
            $faqContent.css({
                // 'max-height': contentHeight + 'px',
                'max-height': 'unset',
                // 'padding': openPadding,
                'opacity': '1'
            });
            $(this).attr('aria-expanded', 'true');
        });
    }

    /**
     * File Upload Preview Functionality
     * 
     * Handles file preview for Contact Form 7 file uploads
     */
    function initFileUploadPreview() {
        // Make upload text clickable to trigger file input
        $(document).on('click', '.upload-wrapper .upload-text', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $input = $(this).closest('.upload-wrapper').find('input[type="file"]');
            if ($input.length > 0) {
                $input[0].click();
            }
        });

        // Function to create preview HTML
        function createPreviewHTML() {
            return `
                <div class="file-preview-content">
                    <div class="file-icon">📄</div>
                    <div class="file-info">
                        <div class="file-name"></div>
                        <div class="file-size"></div>
                    </div>
                    <button type="button" class="file-remove" aria-label="Remove file">×</button>
                </div>
                <div class="file-preview-image"></div>
            `;
        }

        // Function to update preview
        function updatePreview($input, file) {
            const $wrapper = $input.closest('.upload-wrapper');
            const $uploadText = $wrapper.find('.upload-text');
            let $preview = $wrapper.find('.file-preview');
            
            // Create preview container if it doesn't exist
            if ($preview.length === 0) {
                $wrapper.append('<div class="file-preview"></div>');
                $preview = $wrapper.find('.file-preview');
            }

            const fileName = file.name;
            const fileSize = (file.size / 1024 / 1024).toFixed(2) + ' MB';
            const fileType = file.type;

            // Remove error state
            $wrapper.removeClass('has-error');

            // Add has-file class
            $wrapper.addClass('has-file');

            // Update upload text
            $uploadText.text(fileName);

            // Create or update preview content
            let $previewContent = $preview.find('.file-preview-content');
            if ($previewContent.length === 0) {
                $preview.html(createPreviewHTML());
                $previewContent = $preview.find('.file-preview-content');
            }

            // Update file info
            $previewContent.find('.file-name').text(fileName);
            $previewContent.find('.file-size').text(fileSize);

            // Show preview
            $preview.addClass('has-file');

            // Handle image preview
            const $imagePreview = $preview.find('.file-preview-image');
            if (fileType.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = function(e) {
                    $imagePreview.html(`<img src="${e.target.result}" alt="${fileName}">`);
                    $imagePreview.addClass('has-image');
                };
                reader.readAsDataURL(file);
            } else {
                $imagePreview.removeClass('has-image');
                $imagePreview.html('');
            }

            // Handle remove button
            $preview.find('.file-remove').off('click').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                // Clear file input
                $input.val('');
                
                // Clear CF7 validation
                $input.removeClass('wpcf7-not-valid');
                $wrapper.find('.wpcf7-not-valid-tip').remove();
                
                // Reset wrapper
                $wrapper.removeClass('has-file has-error');
                $uploadText.text('Click or Drag to Upload Here');
                $preview.removeClass('has-file');
                $imagePreview.removeClass('has-image').html('');
            });
        }

        // Handle file input change
        $(document).on('change', '.upload-wrapper input[type="file"]', function() {
            const $input = $(this);
            const $wrapper = $input.closest('.upload-wrapper');
            const $uploadText = $wrapper.find('.upload-text');
            let $preview = $wrapper.find('.file-preview');
            const files = this.files;

            if (files && files.length > 0) {
                updatePreview($input, files[0]);
            } else {
                // No file selected
                $wrapper.removeClass('has-file has-error');
                $uploadText.text('Click or Drag to Upload Here');
                if ($preview.length > 0) {
                    $preview.removeClass('has-file');
                }
            }
        });

        // Handle drag and drop
        $(document).on('dragover dragenter', '.upload-wrapper', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).addClass('drag-over');
        });

        $(document).on('dragleave', '.upload-wrapper', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).removeClass('drag-over');
        });

        $(document).on('drop', '.upload-wrapper', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).removeClass('drag-over');
            
            const files = e.originalEvent.dataTransfer.files;
            if (files && files.length > 0) {
                const $input = $(this).find('input[type="file"]');
                if ($input.length > 0) {
                    // Create a new FileList and assign it
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(files[0]);
                    $input[0].files = dataTransfer.files;
                    $input.trigger('change');
                }
            }
        });

        // Handle CF7 validation errors for file uploads
        $(document).on('wpcf7invalid wpcf7spam', function(event) {
            const $form = $(event.target);
            const $fileInputs = $form.find('.upload-wrapper input[type="file"]');
            
            $fileInputs.each(function() {
                const $input = $(this);
                if ($input.hasClass('wpcf7-not-valid')) {
                    const $wrapper = $input.closest('.upload-wrapper');
                    $wrapper.addClass('has-error');
                }
            });
        });

        // Also handle validation on blur/change
        $(document).on('blur change', '.upload-wrapper input[type="file"]', function() {
            const $input = $(this);
            const $wrapper = $input.closest('.upload-wrapper');
            
            // Check if there's a validation error
            if ($input.hasClass('wpcf7-not-valid')) {
                $wrapper.addClass('has-error');
            } else {
                $wrapper.removeClass('has-error');
            }
        });
    }

    /**
     * Fire Meta custom event after a successful Contact Form 7 mail send.
     * Uses trackCustom (not standard Lead) so it stays distinct from other
     * Lead / LEAD BY WEB FORM events already in Events Manager.
     * No PII — only form_id / form_name for breakdown.
     *
     * @param {Event} event CF7 wpcf7mailsent jQuery event
     * @returns {void}
     */
    function trackMetaLeadFromCf7(event) {
        if (typeof fbq !== 'function') {
            return;
        }

        const detail = event.detail || {};
        const formId = detail.contactFormId != null ? String(detail.contactFormId) : '';

        if (!formId) {
            return;
        }

        const formsMap = (window.rifeCf7Meta && window.rifeCf7Meta.forms) ? window.rifeCf7Meta.forms : {};
        const formName = formsMap[formId] || detail.unitTag || ('cf7-' + formId);

        // Custom name — confirm in Test Events as "WEBSITE CONTENT FORM LEAD" only.
        fbq('trackCustom', 'WEBSITE CONTENT FORM LEAD', {
            form_id: formId,
            form_name: formName,
            content_name: formName,
        });
    }

    /**
     * Contact Form 7 Submission Handler
     *
     * Handles Meta Lead tracking and file-upload reset after successful mail.
     */
    function initContactForm7() {
        // Handle form submission - wpcf7-spinner is automatically added by CF7
        // No need to manually add it, just ensure it's styled properly

        // Handle form reset after successful submission
        $(document).on('wpcf7mailsent', function(event) {
            trackMetaLeadFromCf7(event);

            const $form = $(event.target);
            const $uploadWrappers = $form.find('.upload-wrapper');

            // Reset file uploads
            $uploadWrappers.each(function() {
                const $wrapper = $(this);
                const $input = $wrapper.find('input[type="file"]');
                const $preview = $wrapper.find('.file-preview');
                const $uploadText = $wrapper.find('.upload-text');

                $input.val('');
                $wrapper.removeClass('has-file');
                $uploadText.text('Click or Drag to Upload Here');
                $preview.removeClass('has-file');
                $preview.find('.file-preview-image').removeClass('has-image').html('');
            });
        });
    }

    /**
     * Single Post Copy Link Functionality
     * 
     * Handles copying the post URL to clipboard
     */
    function initCopyLink() {
        $('.share-copy-link').on('click', function() {
            const url = $(this).data('url');
            const $button = $(this);
            
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(function() {
                    // Visual feedback
                    const originalHTML = $button.html();
                    $button.html('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/></svg>');
                    $button.css('background-color', '#22C55E');
                    $button.css('border-color', '#22C55E');
                    
                    setTimeout(function() {
                        $button.html(originalHTML);
                        $button.css('background-color', '');
                        $button.css('border-color', '');
                    }, 2000);
                }).catch(function(err) {
                    console.error('Failed to copy: ', err);
                });
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = url;
                textArea.style.position = 'fixed';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                textArea.select();
                
                try {
                    document.execCommand('copy');
                    const originalHTML = $button.html();
                    $button.html('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/></svg>');
                    $button.css('background-color', '#22C55E');
                    $button.css('border-color', '#22C55E');
                    
                    setTimeout(function() {
                        $button.html(originalHTML);
                        $button.css('background-color', '');
                        $button.css('border-color', '');
                    }, 2000);
                } catch (err) {
                    console.error('Fallback copy failed: ', err);
                }
                
                document.body.removeChild(textArea);
            }
        });
    }

    /**
     * Rank Math FAQ Accordion Functionality
     * 
     * Handles the accordion toggle for Rank Math FAQ items
     */
    function initRankMathFAQ() {
        $('.rank-math-question').on('click', function() {
            const $faqItem = $(this).closest('.rank-math-list-item');
            const $faqAnswer = $faqItem.find('.rank-math-answer');
            const isActive = $faqItem.hasClass('active');
            const $allFaqItems = $faqItem.siblings('.rank-math-list-item');
            
            // Close all other FAQ items
            $allFaqItems.removeClass('active');
            $allFaqItems.removeAttr('open');
            $allFaqItems.find('.rank-math-answer').css({
                'max-height': '0',
                'padding': '0 25px'
            });
            
            // Toggle current item
            if (isActive) {
                $faqItem.removeClass('active');
                $faqItem.removeAttr('open');
                $faqAnswer.css({
                    'max-height': '0',
                    'padding': '0 25px'
                });
            } else {
                $faqItem.addClass('active');
                $faqItem.attr('open', 'open');
                const contentHeight = $faqAnswer[0].scrollHeight;
                $faqAnswer.css({
                    'max-height': contentHeight + 'px',
                    'padding': '0 25px'
                });
            }
        });
    }

    /**
     * Search Modal Functionality
     * 
     * Handles opening/closing the search modal overlay
     */
    function initSearchModal() {
        const $searchBtn = $('.header-search-btn');
        const $searchModal = $('#search-modal');
        const $searchInput = $searchModal.find('.search-modal-input');
        const $body = $('body');

        // Open search modal
        $searchBtn.on('click', function(e) {
            e.preventDefault();
            $searchModal.attr('aria-hidden', 'false').addClass('active');
            $body.addClass('search-modal-open');
            
            // Focus on search input after a short delay
            setTimeout(function() {
                $searchInput.focus();
            }, 100);
        });

        // Close search modal
        function closeSearchModal() {
            $searchModal.attr('aria-hidden', 'true').removeClass('active');
            $body.removeClass('search-modal-open');
            $searchInput.val('');
        }

        // Close on ESC key
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $searchModal.hasClass('active')) {
                closeSearchModal();
            }
        });

        // Close on overlay click
        $searchModal.on('click', function(e) {
            if ($(e.target).hasClass('search-modal-overlay')) {
                closeSearchModal();
            }
        });

        // Handle form submission
        $searchModal.find('.search-modal-form').on('submit', function(e) {
            e.preventDefault();
            const searchQuery = $searchInput.val();
            if (searchQuery.trim()) {
                // Get the search URL from data attribute or construct it
                const searchBaseUrl = $searchModal.data('search-url') || window.location.origin + '/';
                const searchUrl = searchBaseUrl + '?s=' + encodeURIComponent(searchQuery);
                window.location.href = searchUrl;
            }
        });
    }

    /**
     * Class Inquiry Modal Functionality
     * 
     * Handles opening/closing the class inquiry modal and pre-filling the class type
     */
    function initClassInquiryModal() {
        const $modal = $('#class-inquiry-modal');
        const $modalOverlay = $('.class-inquiry-modal-overlay');
        const $openButtons = $('.class-inquiry-btn');
        const $closeButton = $('.class-inquiry-modal-close');
        const $body = $('body');

        /**
         * Open modal with class type pre-filled
         * @param {string} classType - The class type value to pre-fill
         */
        function openModalWithClassType(classType) {
            // Open modal
            $modal.attr('aria-hidden', 'false').addClass('active');
            $body.addClass('class-inquiry-modal-open');
            
            // Pre-fill class type - retry until form is loaded
            let attempts = 0;
            const maxAttempts = 20; // Try for up to 2 seconds (20 * 100ms)
            
            function setClassType() {
                const $classTypeSelect = $modal.find('#class-type');
                
                if ($classTypeSelect.length && classType) {
                    // Check if select has options loaded (more than just the placeholder)
                    const hasOptions = $classTypeSelect.find('option').length > 1;
                    
                    if (hasOptions) {
                        // Set the value
                        $classTypeSelect.val(classType);
                        
                        // Trigger multiple events to ensure Contact Form 7 recognizes the change
                        $classTypeSelect.trigger('change');
                        $classTypeSelect.trigger('blur');
                        $classTypeSelect.trigger('input');
                        
                        // Also try setting via native DOM if jQuery doesn't work
                        const nativeSelect = $classTypeSelect[0];
                        if (nativeSelect && nativeSelect.value !== classType) {
                            nativeSelect.value = classType;
                            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        
                        return true; // Success
                    }
                }
                
                attempts++;
                if (attempts < maxAttempts) {
                    setTimeout(setClassType, 100);
                }
                return false;
            }
            
            // Start trying to set the value
            setTimeout(setClassType, 100);
        }

        /**
         * Map URL query parameter values to form select values
         * @param {string} queryValue - The value from URL query parameter
         * @returns {string|null} - The mapped form value or null
         */
        function mapQueryToFormValue(queryValue) {
            if (!queryValue) return null;
            
            const normalizedValue = queryValue.toLowerCase().trim();
            
            // Map URL query values to form select values (form only accepts "Online" or "Offline")
            const mapping = {
                'online': 'Online',
                'offline': 'Offline',
                'online classes': 'Online',
                'offline centre': 'Offline',
                'offline center': 'Offline'
            };
            
            return mapping[normalizedValue] || null;
        }

        // Open modal with class type pre-filled on button click
        $openButtons.on('click', function(e) {
            e.preventDefault();
            const classType = $(this).data('class-type');
            
            // Button data attributes already use "Online" or "Offline" which match form values
            openModalWithClassType(classType);
        });

        // Check for URL query parameters on page load
        function checkUrlQueryParams() {
            const urlParams = new URLSearchParams(window.location.search);
            const classTypeParam = urlParams.get('class-type');
            
            if (classTypeParam) {
                const formValue = mapQueryToFormValue(classTypeParam);
                if (formValue) {
                    openModalWithClassType(formValue);
                    
                    // Clean URL by removing query parameter (optional - keeps URL clean)
                    urlParams.delete('class-type');
                    const newSearch = urlParams.toString();
                    const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
                    window.history.replaceState({}, '', newUrl);
                }
            }
        }

        // Check URL query parameters on page load
        checkUrlQueryParams();

        // Close modal
        function closeModal() {
            $modal.attr('aria-hidden', 'true').removeClass('active');
            $body.removeClass('class-inquiry-modal-open');
        }

        // Close on close button click
        $closeButton.on('click', function(e) {
            e.preventDefault();
            closeModal();
        });

        // Close on ESC key
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $modal.hasClass('active')) {
                closeModal();
            }
        });

        // Close on overlay click
        $modalOverlay.on('click', function(e) {
            if ($(e.target).hasClass('class-inquiry-modal-overlay')) {
                closeModal();
            }
        });
    }

    /**
     * Mobile Menu Functionality
     * 
     * Handles opening/closing the mobile menu offcanvas and submenu toggles
     */
    function initMobileMenu() {
        const $menuToggle = $('#mobile-menu-toggle');
        const $menuOverlay = $('#mobile-menu-overlay');
        const $menuDrawer = $('#mobile-menu-drawer');
        const $menuClose = $('#mobile-menu-close');
        const $body = $('body');

        /**
         * Open mobile menu
         */
        function openMobileMenu() {
            $menuOverlay.attr('aria-hidden', 'false').addClass('active');
            $menuToggle.attr('aria-expanded', 'true');
            $body.addClass('mobile-menu-open');
            
            // Prevent body scroll
            const scrollY = window.scrollY;
            $body.css({
                'position': 'fixed',
                'top': `-${scrollY}px`,
                'width': '100%'
            });
        }

        /**
         * Close mobile menu
         */
        function closeMobileMenu() {
            $menuOverlay.attr('aria-hidden', 'true').removeClass('active');
            $menuToggle.attr('aria-expanded', 'false');
            $body.removeClass('mobile-menu-open');
            
            // Restore body scroll
            const scrollY = $body.css('top');
            $body.css({
                'position': '',
                'top': '',
                'width': ''
            });
            
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
            
            // Close all submenus
            $('.mobile-nav-menu .menu-item-has-children').removeClass('active');
        }

        // Open menu on toggle button click
        $menuToggle.on('click', function(e) {
            e.preventDefault();
            openMobileMenu();
        });

        // Close menu on close button click
        $menuClose.on('click', function(e) {
            e.preventDefault();
            closeMobileMenu();
        });

        // Close menu on overlay click
        $menuOverlay.on('click', function(e) {
            if ($(e.target).hasClass('mobile-menu-overlay')) {
                closeMobileMenu();
            }
        });

        // Close menu on ESC key
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $menuOverlay.hasClass('active')) {
                closeMobileMenu();
            }
        });

        // Handle submenu toggle for mobile menu
        $('.mobile-nav-menu .menu-item-has-children > a').on('click', function(e) {
            const $menuItem = $(this).parent('.menu-item-has-children');
            const isActive = $menuItem.hasClass('active');
            
            // Prevent default link behavior if submenu exists
            if ($menuItem.find('.sub-menu').length > 0) {
                e.preventDefault();
                
                // Toggle active state
                if (isActive) {
                    $menuItem.removeClass('active');
                } else {
                    // Close other submenus
                    $('.mobile-nav-menu .menu-item-has-children').not($menuItem).removeClass('active');
                    // Open clicked submenu
                    $menuItem.addClass('active');
                }
            }
        });
    }

    /**
     * Smooth Scroll for Anchor Links
     * 
     * Handles smooth scrolling to anchor links (e.g., #loan-application)
     */
    function initSmoothScroll() {
        // Handle clicks on anchor links
        $('a[href^="#"]').on('click', function(e) {
            const href = $(this).attr('href');
            
            // Skip if it's just "#" or empty
            if (!href || href === '#' || href === '#!') {
                return;
            }
            
            // Skip if it's a modal trigger or other special link
            if ($(this).hasClass('class-inquiry-btn') || 
                $(this).hasClass('faq-header') ||
                $(this).closest('.faq-header').length > 0) {
                return;
            }
            
            // Find the target element
            const $target = $(href);
            
            if ($target.length) {
                e.preventDefault();
                
                // Calculate offset (accounting for fixed header if any)
                // const headerOffset = $('.site-header').outerHeight() || 0;
                const targetPosition = $target.offset().top - 20; // 20px extra padding
                
                // Smooth scroll to target
                $('html, body').animate({
                    scrollTop: targetPosition
                }, 800, 'swing'); // 800ms duration, swing easing
            }
        });
    }

    // Initialize all functionality on document ready
    $(document).ready(function() {
        initFAQAccordion();
        initFileUploadPreview();
        initContactForm7();
        initCopyLink();
        initRankMathFAQ();
        initSearchModal();
        initClassInquiryModal();
        initMobileMenu();
        initSmoothScroll();
    });

})(jQuery);

